<template>
  <div class="gov-info-box">
    <div class="top-banner-box">
      <div
        class="top-banner-img"
        :style="{ backgroundImage: `url(${headerBgUrl})` }"
      ></div>
    </div>
    <div class="container">
      <div class="top-box" v-show="showTopBox">
        <el-row :gutter="30">
          <el-col
            :span="12"
            class="wow animate__animated animate__fadeInLeftBig"
          >
            <div class="btn-list">
              <div
                class="btn-com"
                :class="
                  btnTopTypeUuid === item.uuid ? 'btn-select' : 'btn-normal'
                "
                v-for="item in btnTopTypeList"
                @click="onClickBtnTopType(item)"
              >
                {{ item.title }}
              </div>
            </div>
            <div
              v-if="infoTopList.length"
              style="cursor: pointer;"
              @click="onClickInfoDetail(infoTopList[0] || null)"
            >
              <div class="over-num-lines top-title">
                {{ infoTopList[0].title || "" }}
              </div>
              <div class="over-num-lines over-2-lines top-des">
                {{ infoTopList[0].summary || "" }}
              </div>
            </div>
            <div class="top-line" />
            <div
              v-for="(item, index) in infoTopList"
              :key="item.uuid"
              class="list-item"
              v-if="index > 0"
              @click="onClickInfoDetail(item)"
            >
              <el-row :gutter="20">
                <el-col :span="18">
                  <div class="top-list over-num-lines">{{ item.title }}</div>
                </el-col>
                <el-col :span="6">
                  <div class="top-list top-date">{{ item.createDate }}</div>
                </el-col>
              </el-row>
            </div>
          </el-col>
          <el-col
            :span="12"
            class="wow animate__animated animate__fadeInRightBig"
          >
            <el-carousel height="360px" :autoplay="true">
              <el-carousel-item v-for="item in carouselList" :key="item.uuid">
                <div
                  class="top-right-img"
                  @click="onClickInfoDetail(item)"
                  :style="{ backgroundImage: `url(${item.pic})` }"
                >
                  <div class="top-right-bottom over-num-lines">
                    <div class="top-right-text">
                      {{ item.title }}
                    </div>
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </el-col>
        </el-row>
      </div>
    </div>
    <div
      class="big-box list-box"
      :style="{ backgroundImage: `url(${govInfoBgUrl})` }"
    >
      <div class="container">
        <div
          class="list-title-img"
          :style="{ backgroundImage: `url(${govInfoTitleUrl})` }"
        ></div>
        <div class="list-btn-box">
          <div class="list-btn-flex">
            <div
              class="list-btn-com"
              :class="btnBottomTypeUuid === item.uuid ? 'list-btn-select' : ''"
              v-for="item in btnBottomTypeList"
              @click="onClickBtnBottomType(item)"
            >
              {{ item.title }}
            </div>
          </div>
          <div class="list-btn-more" @click="onClickListMore">查看更多></div>
        </div>
        <div
          class="wow animate__animated animate__zoomIn list-size"
          v-show="showListBox"
        >
          <el-card
            class="list-item-size"
            v-for="(item, index) in infoBottomList"
            :key="item.uuid"
          >
            <div class="list-item-style" @click="onClickInfoDetail(item)">
              <div class="list-item-left">
                <div class="list-item-name over-num-lines">
                  {{ item.title }}
                </div>
                <div class="list-item-new" v-if="index < 2">最新</div>
                <div class="list-item-num" v-if="item.maxClick">最热</div>
              </div>
              <div class="list-item-date">{{ item.createDate }}</div>
            </div>
          </el-card>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="gov-live">
        <div class="live-title">政务直播</div>
        <div class="live-more" @click="onClickLiveMore">查看更多></div>
        <!--        v-show="showLive"-->
        <div class="live-left-right">
          <div
            class="wow animate__animated animate__fadeInLeft live-left-img"
            :style="{ backgroundImage: `url(${liveSelect.pic})` }"
            @click="onClickLiveDetail()"
          >
            <div class="live-img-mask"></div>
            <div class="live-img-play">
              <i class="el-icon-video-play"></i>
            </div>
          </div>
          <div class="wow animate__animated animate__fadeInRight">
            <div
              class="live-right-img"
              v-for="(item, index) in liveList"
              :class="item.uuid === liveSelect.uuid ? 'live-right-select' : ''"
              :style="{ backgroundImage: `url(${item.pic})` }"
              @click="onChangeLiveItem(item)"
            >
              <div
                :class="item.uuid === liveSelect.uuid ? '' : 'live-img-mask'"
              ></div>
              <i
                v-if="item.uuid === liveSelect.uuid"
                class="live-right-icon el-icon-caret-left"
              ></i>
              <div v-if="item.uuid != liveSelect.uuid" class="live-img-date">
                {{ moment(item.startDate).format("YYYY-MM-DD") }}
              </div>
              <!--              <div v-else class="live-img-play">-->
              <!--                <i class="el-icon-video-play"></i>-->
              <!--              </div>-->
            </div>
          </div>
        </div>
        <div
          v-show="showBottom"
          class="wow animate__animated animate__fadeInUp live-bottom-img"
          @click="onClickLiveDetail()"
        >
          <div style="padding: 20px 30px;">
            <div style="display: flex;">
              <div class="over-num-lines live-bottom-title">
                {{ liveSelect.title }}
              </div>
              <div
                class="live-bottom-status"
                style="border: 1px solid #333333; color: #333333;"
                v-if="liveSelect.stage === 'NOT_START'"
              >
                未开始
              </div>
              <div
                class="live-bottom-status"
                style="border: 1px solid #ff0000; color: #ff0000;"
                v-else-if="liveSelect.stage === 'DOING'"
              >
                直播中
              </div>
              <div
                class="live-bottom-status"
                style="border: 1px solid #9d9d9d; color:#9d9d9d; "
                v-else-if="liveSelect.stage === 'END'"
              >
                已结束
              </div>
            </div>
            <div class="live-bottom-date">
              直播时间：{{ liveSelect.startDate }}~{{ liveSelect.endDate }}
            </div>
            <div class="over-num-lines over-2-lines live-bottom-des">
              {{ liveSelect.summary }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container" v-if="videoList.length">
      <div class="gov-video">
        <div class="video-title">政务视频</div>
        <div class="video-more" @click="onClickVideoMore">查看更多></div>
        <div
          class="wow animate__animated animate__slideInLeft video-list"
          v-show="showVideo"
        >
          <el-row :gutter="20">
            <el-col
              :span="6"
              v-for="item in videoList"
              class="video-item-box"
              :key="item.uuid"
            >
              <div @click="onClickPlayDetail(item, 'video')">
                <div
                  class="video-img"
                  :style="{ backgroundImage: `url(${item.pic})` }"
                >
                  <div class="video-img-mask"></div>
                  <div class="video-img-play">
                    <i class="el-icon-video-play"></i>
                  </div>
                  <!--                  <div class="video-tag">-->
                  <!--                    <span>视频回看</span>-->
                  <!--                  </div>-->
                </div>
                <div class="over-num-lines video-bottom-title">
                  {{ item.title }}
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <div
      class="link-bg gov-link"
      :style="{ backgroundImage: `url(${govInfoLinkUrl})` }"
    >
      <div class="container">
        <div
          class="wow animate__animated animate__slideInUp link-size"
          v-show="showGov"
        >
          <div>
            <div class="link-title">政府部门</div>
            <div
              class="link-box"
              :style="
                govLinkList.length > 5
                  ? 'margin-top: 20px;'
                  : 'margin-top: 50px;'
              "
            >
              <div
                class="link-item"
                v-for="item in govLinkList"
                :key="item.uuid"
                @click="onClickGovLink(item)"
              >
                {{ item.name }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getDictionaryItem,
  getGovHomeBtnList,
  getGovHomeBtnType,
  getGovHomeCarouselList,
  getGovHomeLiveList,
  getGovHomeVideoList,
} from "../../utils/interface"
import { mapState } from "vuex"

export default {
  //   政务信息
  name: "saas",
  metaInfo: {
    title:
      "政务信息 - 为水泵行业企业提供信息化政务信息服务-宁夏工业企业数字化转型公共服务平台",
    meta: [
      {
        name: "keywords",
        content:
          "宁夏工业企业数字化转型公共服务平台 | 信息化软件 | 智能制造解决方案| 水泵数字化| saas平台 | 平台软件服务 | 企业数字化服务| 企业管理软件",
      },
      {
        name: "description",
        content:
          "宁夏工业企业数字化转型公共服务平台软件超市提供人力资源、行政、采购、营销、财务、党政等信息化产品软件服务，为水泵行业企业提供完整的信息化解决方案。",
      },
    ],
  },
  components: {},
  data() {
    return {
      headerBgUrl: "",
      govInfoBgUrl: require("../../assets/govInfoBg.png"),
      govInfoTitleUrl: require("../../assets/govInfoTitle.png"),
      govInfoLiveUrl: require("../../assets/govInfoLive.png"),
      govInfoLinkUrl: require("../../assets/govInfoLink.png"),
      govLinkList: [],
      showTopBox: false,
      showListBox: false,
      showLive: false,
      showBottom: false,
      showVideo: false,
      showGov: false,
      btnTopTypeUuid: "",
      btnTopTypeList: [],
      btnBottomTypeUuid: "",
      btnBottomTypeList: [],
      infoTopList: [],
      infoBottomList: [],
      carouselList: [],
      liveList: [],
      liveSelect: {},
      videoList: [],
    }
  },
  computed: {
    ...mapState({
      isTokenDoor: "isTokenDoor",
    }),
  },
  created() {
    if (this.$store.state.isLogin) {
    } else {
    }
    this.getOptionsData()
  },
  mounted() {
    this.showTopBox = true
    window.addEventListener("scroll", this.menu)
  },
  methods: {
    onClickInfoDetail(item) {
      if (item) {
        let routeData = this.$router.resolve({
          name: "govInfoDetail",
          query: {
            uuid: item.uuid,
            titleName: "政务信息",
            titleForm: "govInfoDetail",
          },
        })
        window.open(routeData.href, "_blank")
      }
    },
    getOptionsData() {
      //顶部轮播图
      getDictionaryItem({
        code: "ZWXX_BANNER",
      }).then((res) => {
        if (res != null && res.length > 0) {
          this.headerBgUrl = res[0].value
        } else {
          this.headerBgUrl = ""
        }
      })
      //上面分类列表
      getGovHomeBtnType({ pageSize: "99", position: "1", status: "1" }).then(
        (res) => {
          if (res.list) {
            this.btnTopTypeList = res.list
            this.btnTopTypeUuid = res.list[0].uuid
            this.queryGovHomeBtnTopList()
          }
        }
      )
      //下面分类列表
      getGovHomeBtnType({ pageSize: "99", position: "2", status: "1" }).then(
        (res) => {
          if (res.list) {
            this.btnBottomTypeList = res.list
            this.btnBottomTypeUuid = res.list[0].uuid
            this.queryGovHomeBtnBottomList()
          }
        }
      )
      //顶部轮播图
      getGovHomeCarouselList({ isRecommend: "1", status: "1" }).then((res) => {
        if (res) {
          this.carouselList = res
        }
      })
      //直播列表
      getGovHomeLiveList({ pageSize: "3", rec: "1" }).then((res) => {
        if (res.list) {
          this.liveList = res.list
          this.liveSelect = res.list[0]
        }
      })
      //视频列表
      getGovHomeVideoList({ pageSize: "8", rec: "1" }).then((res) => {
        if (res.list) {
          this.videoList = res.list
        }
      })
      //底部政府链接
      getDictionaryItem({
        groupCode: "ZWXX_ZFBM",
      }).then((res) => {
        if (res) {
          this.govLinkList = res
        }
      })
    },
    queryGovHomeBtnTopList() {
      getGovHomeBtnList({
        pageSize: "6",
        programUuid: this.btnTopTypeUuid,
        status: "1",
      }).then((res) => {
        if (res.list) {
          this.infoTopList = res.list
        }
      })
    },
    queryGovHomeBtnBottomList() {
      getGovHomeBtnList({
        pageSize: "5",
        programUuid: this.btnBottomTypeUuid,
        status: "1",
      }).then((res) => {
        if (res.list) {
          this.infoBottomList = res.list
          let maxClickNum = 0
          let maxClickIndex = 0
          this.infoBottomList.forEach((item, index) => {
            if (maxClickNum < item.viewCount) {
              maxClickNum = item.viewCount
              maxClickIndex = index
            }
          })
          this.infoBottomList[maxClickIndex].maxClick = true
        }
      })
    },
    onClickBtnTopType(item) {
      this.btnTopTypeUuid = item.uuid
      this.queryGovHomeBtnTopList()
    },
    onClickBtnBottomType(item) {
      this.btnBottomTypeUuid = item.uuid
      this.queryGovHomeBtnBottomList()
    },
    onClickListMore() {
      let routeData = this.$router.resolve({
        path: "/govInfoList",
      })
      window.open(routeData.href, "_blank")
    },
    onClickLiveMore() {
      let routeData = this.$router.resolve({
        path: "/govLiveList",
      })
      window.open(routeData.href, "_blank")
    },
    onChangeLiveItem(item) {
      this.liveSelect = item
    },
    onClickLiveDetail() {
      this.onClickPlayDetail(this.liveSelect, "live")
    },
    onClickPlayDetail(item, type) {
      let routeData = this.$router.resolve({
        path: "/govPlayDetail",
        query: {
          uuid: item.uuid,
          type: type,
          titleName: "政务信息",
          titleForm: "govInfo",
        },
      })
      window.open(routeData.href, "_blank")
    },
    onClickGovLink(item) {
      window.open(item.value, "_blank")
    },
    onClickVideoMore() {
      let routeData = this.$router.resolve({
        path: "/govVideoList",
      })
      window.open(routeData.href, "_blank")
    },
    // 页面滚动
    menu() {
      let scroll = document.documentElement.scrollTop || document.body.scrollTop
      // console.log(scroll)
      //动态计算高度
      let infoHeight = (5 - this.infoBottomList.length) * (80 + 18)
      let videoHeight = 440
      if (this.videoList.length > 0) {
        if (this.videoList.length > 0 && this.videoList.length < 4) {
          videoHeight = 220
        } else {
          videoHeight = 0
        }
      }
      if (scroll > 300) {
        this.showListBox = true
      }
      if (scroll > 1100 - infoHeight) {
        this.showLive = true
      }
      if (scroll > 1380 - infoHeight) {
        this.showBottom = true
      }
      if (scroll > 1800 - infoHeight) {
        this.showVideo = true
      }
      if (scroll > 2250 - infoHeight - videoHeight) {
        this.showGov = true
      }
    },
  },
}
</script>

<style scoped lang="less">
@basic-colors: #009999;

.gov-info-box {
  background-color: #ffffff;

  //超出指定行换行
  .over-num-lines {
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
  }

  .over-1-lines {
    -webkit-line-clamp: 1;
  }

  .over-2-lines {
    -webkit-line-clamp: 2;
  }

  .container {
    width: 1200px;
    margin: 0 auto;
    padding-bottom: 10px;
  }

  .big-box {
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }

  .con-title {
    font-size: 36px;
    font-weight: bold;
    color: white;
    text-align: center;
    padding-top: 35px;
    margin-top: 15px;
  }

  .con-small-title {
    color: #333333;
    text-align: center;
    margin-top: 10px;
  }

  .top-banner-box {
    .top-banner-img {
      height: 500px;
      width: 100%;
      overflow: hidden;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .top-box {
    margin-top: 50px;

    .btn-list {
      display: flex;
    }

    .btn-com {
      width: 110px;
      height: 32px;
      line-height: 32px;
      margin-right: 10px;
      text-align: center;
      border-radius: 16px;
      cursor: pointer;
      transition: all 0.1s;
      user-select: none;
    }

    .btn-com:hover {
      color: @basic-colors;
    }

    .btn-select {
      background-color: @basic-colors;
      color: white;
    }

    .btn-select:hover {
      color: white;
    }

    .btn-normal {
      border: 1px solid #d9d9d9;
    }

    .top-title {
      font-size: 20px;
      font-weight: bold;
      color: #000;
      margin-top: 25px;
    }

    .top-des {
      margin-top: 15px;
      font-size: 16px;
      color: #777777;
      line-height: 24px;
    }

    .top-date {
      text-align: right;
      color: #777777 !important;
    }

    .list-item {
      color: #000;
      cursor: pointer;
    }

    .list-item:hover {
      .top-list {
        color: @basic-colors !important;
      }

      //.top-date {
      //  color: #777777 !important;
      //}
    }

    .top-list {
      font-size: 16px;
      color: #000;
      line-height: 32px;
    }

    .top-right-img {
      height: 360px;
      width: 100%;
      overflow: hidden;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      cursor: pointer;
    }

    .top-right-bottom {
      position: absolute;
      bottom: 0;
      color: white;
      background: rgba(0, 0, 0, 0.4);
      height: 55px;
      line-height: 55px;
      width: 100%;
    }

    .top-right-text {
      width: 70%;
      margin-left: 20px;
      font-size: 16px;
      font-weight: bold;
    }

    /deep/ .el-carousel__indicators--horizontal {
      bottom: 3.2%;
      left: 100%;
      width: 30%;
    }

    /deep/ .el-carousel__button {
      width: 8px;
      height: 8px;
      border-radius: 50%;
    }

    .top-line {
      width: 100%;
      height: 1px;
      background-color: #e5e6e8;
      margin: 22px 0;
    }
  }

  .list-box {
    max-height: 660px;
    margin-top: 25px;

    .list-title-img {
      height: 63px;
      width: 1100px;
      overflow: hidden;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      margin: auto;
    }

    .list-btn-box {
      margin-top: 30px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .list-btn-flex {
      display: flex;
    }

    .list-btn-com {
      font-size: 22px;
      height: 22px;
      line-height: 22px;
      font-weight: bold;
      color: #000;
      border-right: 1px solid #d3d3d3;
      padding-right: 20px;
      margin-right: 20px;
      cursor: pointer;
      user-select: none;
      transition: all 0.2s;
    }

    .list-btn-com:hover {
      color: @basic-colors;
    }

    .list-btn-com:last-child {
      border-right: none;
      margin-right: 0;
    }

    .list-btn-select {
      color: @basic-colors;
    }

    .list-btn-more {
      font-size: 14px;
      cursor: pointer;
    }

    .list-btn-more:hover {
      color: @basic-colors;
    }

    .list-size {
      margin-top: 35px;
    }

    .list-item-style {
      padding: 8px;
      display: flex;
      justify-content: space-between;
    }

    .list-item-size {
      margin-bottom: 18px;
      cursor: pointer;
      transition: all 0.2s;
    }

    .list-item-size:hover {
      //transform: scale(1.01);

      .list-item-name {
        color: @basic-colors;
      }

      .list-item-left {
        transform: scale(1.01);
      }
    }

    .list-item-left {
      display: flex;
      transition: all 0.2s;
      color: #000;
    }

    .list-item-name {
      font-size: 16px;
      max-width: 850px;
    }

    .list-item-new {
      color: #ff5e55;
      border: 1px solid #ff5e55;
      padding: 1px 15px 0 15px;
      border-radius: 15px;
      font-size: 14px;
      line-height: 16px;
      margin-left: 10px;
    }

    .list-item-num {
      color: @basic-colors;
      border: 1px solid @basic-colors;
      padding: 1px 12px 0 12px;
      border-radius: 15px;
      font-size: 14px;
      line-height: 16px;
      margin-left: 10px;
    }

    .list-item-date {
      color: #777;
    }
  }

  .gov-live {
    margin-top: 15px;

    .live-title {
      font-size: 24px;
      font-weight: bold;
      color: #000;
      text-align: center;
    }

    .live-left-right {
      display: flex;
    }

    .live-img-mask {
      background-color: rgba(0, 0, 0, 0.5);
      width: 100%;
      height: 100%;
    }

    .live-img-date {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      color: #ffffff;
      font-weight: bold;
      background-color: rgba(255, 255, 255, 0.2);
      border: 1px solid #adadad;
      border-radius: 8px;
      padding: 8px 20px;
      font-size: 26px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .live-img-play {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      color: #ffffff;
      //background-color: #526396;
      border-radius: 50%;
      width: 70px;
      height: 70px;
      font-size: 60px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }

    .live-img-play:hover {
      font-size: 62px;
    }

    //
    //.live-img-play:active {
    //  width: 70px;
    //  height: 70px;
    //  font-size: 38px;
    //}

    .el-icon-video-play {
      //font-weight: bold;
    }

    .live-left-img {
      background-repeat: no-repeat;
      background-size: 100% 100%;
      width: 930px;
      height: 500px;
      margin-right: calc(100% - 930px - 256px);
      position: relative;
      cursor: pointer;
    }

    .live-right-img {
      background-repeat: no-repeat;
      background-size: 100% 100%;
      width: 256px;
      height: 158px;
      margin-bottom: 10px;
      cursor: pointer;
      position: relative;

      .live-img-date {
        border-radius: 5px;
        padding: 7px 15px;
        font-size: 16px;
      }

      .live-img-play {
        width: 45px;
        height: 45px;
        font-size: 40px;
      }

      //.live-img-play:hover {
      //  width: 47px;
      //  height: 47px;
      //  font-size: 23px;
      //}
      //
      //.live-img-play:active {
      //  width: 45px;
      //  height: 45px;
      //  font-size: 22px;
      //}
    }

    .live-right-img:last-child {
      margin-bottom: 0;
    }

    .live-right-select {
      border: 3px solid @basic-colors;
      width: calc(256px - 3px);
      height: calc(158px - 3px);
    }

    .live-right-icon {
      color: @basic-colors;
      font-size: 34px;
      position: absolute;
      left: -23px;
      top: 50%;
      transform: translateY(-50%);
    }

    .live-more {
      margin-bottom: 10px;
      width: 100%;
      text-align: right;
      cursor: pointer;
      font-size: 14px;
    }

    .live-bottom-img {
      color: #000;
      margin-top: 5px;
      width: 100%;
      height: 170px;
      background-color: #f2f2f2;
      cursor: pointer;
    }

    .live-bottom-title {
      font-size: 22px;
      font-weight: bold;
      max-width: 90%;
    }

    .live-bottom-status {
      font-size: 14px;
      height: 21px;
      padding: 1px 12px;
      //background: #E63E1D;
      border-radius: 8px;
      //border: 1px solid #FFFFFF;
      margin: auto 15px;
    }

    .live-bottom-des {
      margin-top: 10px;
      font-size: 14px;
      line-height: 24px;
      color: #767272;
    }

    .live-bottom-date {
      margin-top: 22px;
      font-size: 16px;
      line-height: 24px;
    }
  }

  .gov-video {
    margin-top: 25px;

    .video-title {
      font-size: 24px;
      font-weight: bold;
      color: #000;
      text-align: center;
    }

    .video-more {
      width: 100%;
      text-align: right;
      cursor: pointer;
      font-size: 14px;
    }

    .video-list {
      margin-top: 10px;
    }

    .video-img {
      background-repeat: no-repeat;
      background-size: 100% 100%;
      width: 290px;
      height: 170px;
      margin-bottom: 8px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
      transition: all 0.3s;
      box-shadow: rgba(0, 0, 0, 0.35) 0 5px 15px;
    }

    .video-item-box:hover {
      .video-img {
        transform: scale(1.02);
      }

      .video-bottom-title {
        color: @basic-colors;
      }
    }

    .video-img-mask {
      background-color: rgba(0, 0, 0, 0.5);
      width: 100%;
      height: 100%;
    }

    .video-img-play {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      color: #ffffff;
      //background-color: #526396;
      border-radius: 50%;
      width: 45px;
      height: 45px;
      font-size: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }

    //.video-img-play:hover {
    //  width: 47px;
    //  height: 47px;
    //  font-size: 31px;
    //}
    //
    //.video-img-play:active {
    //  width: 45px;
    //  height: 45px;
    //  font-size: 30px;
    //}

    .video-tag {
      width: 90px;
      height: 90px;
      position: absolute;
      top: -45px;
      right: -45px;
      transform: rotate(45deg);
    }

    .video-tag span {
      position: absolute;
      bottom: 0;
      padding: 2px 0 3px 0;
      display: block;
      font-size: 12px;
      color: #fff;
      background: @basic-colors;
      width: 90px;
      text-align: center;
    }

    .video-bottom-title {
      font-size: 16px;
      color: #000;
      text-align: center;
      margin-bottom: 20px;
      padding: 0 20px 0 8px;
    }
  }

  .gov-link {
    height: 310px;

    .link-bg {
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }

    .link-title {
      font-size: 24px;
      font-weight: bold;
      color: white;
      text-align: center;
      margin-top: 40px;
      word-spacing: 1px;
    }

    .link-size {
      height: 310px;
      width: 100%;
      display: flex;
      justify-content: center;
    }

    .link-box {
      margin-top: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;
    }

    .link-item {
      background-color: rgba(255, 255, 255, 0.22);
      width: 200px;
      height: 60px;
      line-height: 60px;
      text-align: center;
      font-weight: bold;
      color: white;
      font-size: 18px;
      padding: 10px;
      margin: 10px;
      cursor: pointer;
      word-spacing: 1px;
    }

    //.link-item:hover {
    //  color: @basic-colors;
    //}
  }
}
</style>



// WEBPACK FOOTER //
// src/components/govInfo/index.vue